interface RelationResourceProps {
  resource: { title: string; link: string; icon: string; position: number }[];
}

export const RelationResource = ({ resource }: RelationResourceProps) => {
  if (resource.length === 0) return null;

  return (
    <div className="flex flex-wrap md:grid-cols-2 gap-[10px] max-w-[680px]">
      {resource.slice(0, 4).map((item, index) => {
        const url = new URL(item.link);
        const openLink = () => {
          window.open(item.link, "_blank");
        };
        return (
          <div
            key={index}
            className="p-[15px] bg-[#FAFAFA]  border border-[#F1F1F1] rounded-[5px] transition-all duration-300 transition-[cubic-bezier(.22, .58, .12, .98)] hover:shadow-[0_5px_20px_#00000012] group max-w-[250px] dark:bg-[#1E1E1E] dark:border-none"
          >
            <div className="line-clamp-2 h-[40px] leading-[20px] dark:text-[#F1F1F1]">{item.title}</div>
            <div>
              <div className="align-center flex items-center justify-between pt-[10px]">
                <img src={item.icon} alt={item.title} className="h-[15px] w-[15px] flex-shrink-0 mr-[5px]" />
                <div className="align-center w-[160px] inline-flex items-center font-roboto text-[#b3b3b3] text-[12px] truncate">
                  <span className="truncate">
                    {url.hostname}
                    <span className="px-[5px] font-extrabold">·</span>
                    {item.position}
                  </span>
                </div>
                <div className="flex items-center gap-[7px]">
                  <div className="flex justify-center items-center h-[20px] w-[20px] shrink-0 cursor-pointer border border-[#CBD5E1] rounded-[5px]  text-center opacity-0 transition group-hover:opacity-100">
                    <img src="/herm-chat/quote.svg" alt="quote" className="w-[12px]" />
                  </div>
                  <div
                    onClick={openLink}
                    className="flex justify-center items-center h-[20px] w-[20px] shrink-0 cursor-pointer border border-[#CBD5E1] rounded-[5px]  text-center opacity-0 transition group-hover:opacity-100"
                  >
                    <img src="/herm-chat/link.svg" alt="link" className="w-[12px]" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
